import type { PaginationResponse } from "@/types/serverResponse";
import { axios_instance } from "./api";

export interface LastActivity {
  id: string;
  scan_id: string;
  agent_id: string;
  created_at: number;
  action_time: number;
  description: string;
  file_name: string;
  full_path: string;
  more_information: string;
  file_extension: string;
  data_source: string;
}

export const fetchLastActivity = (
  agent_id: string,
  action_id: string,
  keyword: string = "",
  page: number = 1,
  size: number = 10,
) => {
  const payload = {
    keyword,
    agent_id,
    action_id,
    page,
    size,
  };

  return axios_instance.post<PaginationResponse<LastActivity>>(
    "/api/v1/view/last-activity/pagination",
    payload,
  );
};
